module.exports = __webpack_public_path__ + "static/media/Inspiration-scroll@shortened.d7603b0c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/Inspiration-scroll@shortened.gif
// module id = 203
// module chunks = 0